import { useCallback, useState } from 'react';

const NEW_LINE = '\n';

export const useExpandableTextField = (maxRows: number) => {
  const [rows, setRows] = useState(1);

  const handleRowsChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const lineCount = event.target.value.split(NEW_LINE).length;
      setRows(Math.min(lineCount, maxRows));
    },
    [maxRows],
  );

  return { rows, setRows, handleRowsChange };
};
